export enum ChangelogTypeEnum {
  T = 'T', // feature
  F = 'F', //fix
  I = 'I',
  P = 'P',
  D = 'D',
}
